import React, { useCallback, useEffect, useState } from "react";
import BetDetailsPopup from "../accounts/BetDetailsPopup";
//import LedgerPopUp from "../popup/ledger-popup";
import { useParams } from "react-router-dom";
import axiosInstance from "../../../utils/axiosInstance";

const ClientPopUpPage = () => {
  const { type, userId } = useParams();
  const [pageLoad, setPageLoad] = useState(false);
  const [userData, setuserData] = useState([]);
  const [displayMode, setDisplayMode] = useState("Cash");
  const [creditDebitObj, setCreditDebitObj] = useState({});

  let CashDepositTxt = "";
  let CashWithTxt = "";

  let CreditDepositTxt = "";
  let CreditWithTxt = "";

  const changeMode = (mode) => {
    setDisplayMode(mode);
  };

  useEffect(() => {
    const fetchUserById = async () => {
      setPageLoad(true);
    };
    fetchUserById();
  }, []);

  return (
    <div>
      <div
        style={{
          width: "100%",
          textAlign: "center",
          display: pageLoad ? "none" : "block"
        }}
      >
        <img src="../../../assets/images/loadinggif.gif" alt="Loader" />
      </div>

      <div style={{ display: pageLoad ? "" : "none" }}>
        <BetDetailsPopup userData={userData}></BetDetailsPopup>
      </div>
    </div>
  );
};

export default ClientPopUpPage;
